import React, { useRef, useEffect, useContext } from "react";
import mapboxgl from "mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { AppContext } from "../../../../../components/global/appContext";

export default function MapboxMap(props) {
  const appContext = useContext(AppContext);
  mapboxgl.accessToken = appContext.mapboxAdminToken;

  const mapContainer = useRef(null);
  const map = useRef(null);
  const marker = useRef(null);
  const lat = props.locationCoords ? props.locationCoords.lat : 40;
  const lng = props.locationCoords ? props.locationCoords.lng : 0;
  const zoom = props.locationCoords ? 14 : 1;

  useEffect(() => {
    // Initialize map
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/light-v10",
      center: [lng, lat],
      zoom: zoom,
    });
    // Initialize marker
    if (props.locationCoords) {
      createMarker(lng, lat);
    }
  });
  useEffect(() => {
    if (!props.locationCoords) return;
    const { lng, lat } = props.locationCoords;
    if (!marker.current) {
      // If we have got location coords and no marker, create a marker
      createMarker(lng, lat);
    }
    marker.current.setLngLat([lng, lat]);
  }, [props.locationCoords]);

  function createMarker(lng, lat) {
    if (!map.current) return;
    marker.current = new mapboxgl.Marker({
      color: "#f6175b",
      draggable: true,
    })
      .setLngLat([lng, lat])
      .addTo(map.current);
    marker.current.on("dragend", handleMarkerMove);

    map.current.flyTo({ center: [lng, lat], zoom: 14 });
  }

  function handleMarkerMove() {
    if (!marker.current) return;
    const coords = marker.current.getLngLat();
    map.current.flyTo({ center: coords });
    props.setLocationCoords({ lat: coords.lat, lng: coords.lng });
  }

  return (
    <div>
      <div
        ref={mapContainer}
        className="map-container"
        style={{ height: "260px" }}
      />
    </div>
  );
}
